module.exports = __webpack_public_path__ + "static/media/berlinmur.4ece15e8.jpg";